<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <b-navbar-brand to="/">
        <img title="Startseite" src="../assets/logo.png">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse">
        <template v-slot:default="{ expanded }">
          <b-icon v-if="expanded" icon="x" scale="2" flip-h></b-icon>
          <b-icon v-else icon="list" scale="2"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item class="nav-link" v-for="route in bigNavs" :key="route.path" :to="route.path">
            <span v-html="route.name"></span>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item class="nav-link small" v-for="route in smallNavs" :key="route.path" :to="route.path">
            {{ route.name }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  created() {
        this.$router.options.routes.forEach(route => {
            this.items.push({
                name: route.name,
                path: route.path
            })
        })
    },
    data() {
        return {
            items: [],
            smallItems: ["Über uns", "Lehre", "Kontakt", "Karriere"]
        }
    },
    computed: {
      bigNavs: function () {
        var smallItems = this.smallItems
        return this.items.filter(function(item) {return (!smallItems.includes(item.name) && item.name != 'Startseite' && item.name != 'Impressum');});
      },
      smallNavs: function () {
        var smallItems = this.smallItems
        return this.items.filter(function(item) {return smallItems.includes(item.name);});
      }
    }
}
</script>

<style scoped>
.navbar-nav.ml-auto {
  flex-direction: row!important;
  justify-content: space-evenly;
}

.small a.nav-link {
  padding-top: 24px;
}

.small {
  height: 100%!important;
  flex-grow: 1!important;
  text-align: center;
  font-size: 1rem;
}

.navbar-nav.ml-auto, .navbar-nav.ml-auto a.nav-link {
  height: 75px!important;
}

.navbar-nav.ml-auto a.nav-link {
  align-items: flex-end;
  /*padding-top: 40px;*/
}

a.nav-link:hover, .nav-link.router-link-exact-active {
  background-color: rgba(0, 0, 0, 0.1);
}

a.nav-link {
  height: 100%!important;
}

.nav-link.router-link-exact-active{
  color: white!important;
}

li.nav-item {
  padding-left: 0!important;
  padding-right: 0!important;
}

a.nav-link {
  padding-left: 12px!important;
  padding-right: 12px!important;
}

.show a.nav-link, .collapsing a.nav-link  {
  padding-left: 15px;
}

.nav-item {
  padding-top: 0;
  padding-bottom: 0;
}

.navbar {
  min-height: 75px;
  padding: 0;
  margin: 0;
}

.navbar-brand {
  padding: 0;
  padding-left: 15px;
  padding-right: 15px;
  height: 75px;
  line-height: 75px;
}

.navbar-expand-lg {
  flex-wrap: wrap!important;
}

.navbar-toggle {
  /* (80px - button height 34px) / 2 = 23px */
  margin-top: 20.5px;
  padding: 9px 10px !important;
}

.navbar-toggler {
  margin-right: 10px!important;
}

.navbar-nav {
  padding: 0;
  margin: 0;
}

@media (min-width: 992px) {
  .navbar-nav > li > a {
    /* (80px - line-height of 27px) / 2 = 26.5px */
    padding-top: 24px;
    padding-bottom: 24px;
    line-height: 27px;
  }
}

.navbar-dark .navbar-toggler {
  border-color: rgba(255, 255, 255, 0)!important;
}

img {
  height: 70px;
  margin: 0;
  padding: 0;
  font-size: 0;
}

</style>
